import styled from 'styled-components'
import AntdDivider from 'antd/lib/divider'
import { DARKER_GRAY } from '../../../theme/colors'

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: 38px;
  position: relative;
  padding: 4px 0;
`

interface SelectedProps {
  selected: boolean
  activeOnClick?: boolean
  index?: number
}

export const ShapeContainer = styled.div`
  width: 10px;
  height: 32px;
  background: #dcdcdc;
  position: absolute;
  left: 100%;
  z-index: 1;
  clip-path: polygon(0 0, 0% 100%, 100% 50%);
`

export const OpeningShape = styled.div`
  background-color: ${({ selected }: SelectedProps) =>
    selected ? '#b58fff' : '#fff'};
  width: 10px;
  height: 100%;
  position: absolute;
  right: 1px;
  z-index: 2;
  clip-path: polygon(0 0, 0% 100%, 100% 50%);
`

export const Tab = styled.div`
  display: flex;
  flex: 1;
  background: ${({ selected }: SelectedProps) =>
    selected
      ? 'linear-gradient(to right,#9bbeff,#b68fff 90%)'
      : '#fff'};
  justify-content: center;
  align-items: center;
  border-top-left-radius: ${({ index }: SelectedProps) =>
    index === 0 ? '10px' : '0px'};
  border-bottom-left-radius: ${({ index }: SelectedProps) =>
    index === 0 ? '10px' : '0px'};
  cursor: ${({ activeOnClick }: SelectedProps) =>
    activeOnClick ? 'pointer' : 'default'};

  &:hover {
    background-color: ${({ activeOnClick, selected }: SelectedProps) => {
      if (selected) {
        return '#e61737'
      }
      return activeOnClick ? '#fafafa' : '#fff'
    }};
    }
  }
`

export const Text = styled.div`
  font-size: 14px;
  line-height: 19px;
  color: ${({ selected }: SelectedProps) => (selected ? '#fff' : DARKER_GRAY)};

  @media (max-width: 1024px) {
    font-size: 12px;
  }
`

export const Divider = styled(AntdDivider)`
  height: 33px;
  margin: 0px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterTabsV1Temp/Tab/styledComponents.tsx